import React, { useEffect, useState } from "react";
import { Trash2, Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { PageTitle } from "./shared";

const ENQUIRY_STATUS = [
  { value: "new", label: "NEW" },
  { value: "replied", label: "REPLIED" },
  { value: "closed", label: "CLOSED" },
];

const Enquiries = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/enquiries").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  const setStatus = async (id, status) => {
    await api.patch(`/admin/enquiries/${id}`, { status });
    setItems((list) => list.map((e) => (e.id === id ? { ...e, status } : e)));
    toast.success("Enquiry updated");
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this enquiry?")) return;
    await api.delete(`/admin/enquiries/${id}`);
    setItems((list) => list.filter((e) => e.id !== id));
    toast.success("Enquiry deleted");
  };

  return (
    <div data-testid="console-enquiries">
      <PageTitle kicker="CRM" title="ENQUIRIES" />
      {items === null ? (
        <p className="text-plum-deep/60">Loading…</p>
      ) : items.length === 0 ? (
        <p className="text-plum-deep/60" data-testid="enquiries-empty">No enquiries yet.</p>
      ) : (
        <div className="space-y-3">
          {items.map((e) => (
            <div key={e.id} className="bg-warmwhite border border-plum-deep/10 rounded-[1.25rem] p-5" data-testid={`enquiry-row-${e.id}`}>
              <div className="flex flex-wrap items-center gap-3">
                <p className="font-semibold text-sm">{e.name}</p>
                <a href={`mailto:${e.email}`} className="inline-flex items-center gap-1.5 text-magenta text-sm hover:underline">
                  <Mail className="w-3.5 h-3.5" /> {e.email}
                </a>
                <span className="text-xs text-plum-deep/50 ml-auto">{new Date(e.created_at).toLocaleString("en-NZ")}</span>
                <select
                  value={e.status}
                  onChange={(ev) => setStatus(e.id, ev.target.value)}
                  data-testid={`enquiry-status-${e.id}`}
                  className="rounded-full px-3 py-1.5 bg-cream border border-plum-deep/15 text-xs focus:outline-none focus:border-magenta"
                >
                  {ENQUIRY_STATUS.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
                </select>
                <button onClick={() => remove(e.id)} className="text-plum-deep/40 hover:text-red-600" data-testid={`enquiry-delete-${e.id}`} aria-label="Delete enquiry">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              {e.subject && <p className="mt-2 text-sm font-medium">{e.subject}</p>}
              <p className="mt-1 text-sm text-plum-deep/80">{e.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Enquiries;
